import React from 'react'

export const VisibilityOffIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 10.6944C7.08738 10.6944 4.17082 8.67872 3 5.83333M10.5 10.6944C13.9126 10.6944 16.8292 8.67872 18 5.83333M10.5 10.6944L10.5 14.1667M6 9.38991L3.34835 11.8451M15 9.38991L17.6517 11.8451"
      stroke="#1D2943"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)
